import React from 'react';
import PropTypes from 'prop-types';
import { ALL_PLATFORMS } from '../../constants';

/**
 * Platform Selector Component
 * Allows filtering data by platform
 * @param {Object} props - Component props
 * @param {string|null} props.platform - Currently selected platform
 * @param {Function} props.onPlatformChange - Platform change handler
 * @param {string} [props.className] - Additional CSS classes
 */
const PlatformSelector = ({ platform, onPlatformChange, className = '' }) => {
  const platforms = ALL_PLATFORMS.map(({ value, label }) => ({ value, label }));

  return (
    <div className={`platform-selector ${className}`}>
      <label className="filter-label">Platform</label>
      <select
        value={platform || ''}
        onChange={(e) => onPlatformChange(e.target.value || null)}
        className="platform-select"
      >
        {platforms.map(({ value, label }) => (
          <option key={value || 'all'} value={value || ''}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

PlatformSelector.propTypes = {
  platform: PropTypes.string,
  onPlatformChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default PlatformSelector;
